import { CategoryPage } from 'routes/Articles/Category'
import { getArticlesByCategorySlug, getCategoryBySlug } from 'helpers/strapi'
import { ArticleType, CategoryType } from 'helpers/strapi/types'
import { CATEGORY_REVALIDATE_TIME } from 'routes/constants'
// import { fetchCategories } from 'helpers/strapi/fetch-strapi'

export default function Category({
  category,
  articles,
}: {
  category: CategoryType
  articles: ArticleType[]
}) {
  return <CategoryPage category={category} articles={articles} />
}

export async function getStaticPaths() {
  // const categories = await fetchCategories({})
  return {
    paths: [],
    // paths: categories.data
    //   .map((category) => category.attributes.slug)
    //   .filter((slug) => !HIDDEN_CATEGORIES.includes[slug])
    //   .map((slug) => ({
    //     params: { category: slug },
    //   })),
    fallback: true, // or false or "blocking"
  }
}

export async function getStaticProps({
  params,
}: {
  params: { category: string }
}) {
  const category = await getCategoryBySlug(params.category)
  const articles = await getArticlesByCategorySlug(params.category)

  if (!category) {
    return {
      redirect: {
        permanent: false,
        destination: './', // Redirect to Category page
      },
    }
  }

  return {
    props: {
      category,
      articles,
    },
    revalidate: CATEGORY_REVALIDATE_TIME, // In seconds
  }
}
